// @ts-nocheck
import React from 'react'
import Header from './layout/Header'
import Footer from './layout/Footer'
import useFetch from '../../ApiClient/GetApi'

export default function TermsConditions() {
    const {data} = useFetch("users/home/terms_and_conditions");
    
  return (
    <>
    <section className="font-fiexen">
      <Header />
        <div className='w-5/6 mx-auto py-20'>
        <h1 className='text-2xl font-semibold text-themeBlue'>Terms & Conditions</h1>
        <div dangerouslySetInnerHTML={{ __html: data?.data?.value }} />
        </div>
      <Footer />
    </section>
  </>
  )
}
